import React, { useContext, useEffect, useState } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'
import moment from 'moment';
import { CommentReply } from './'
import { getUserByID } from '../../api/auth'

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deleteComment, likeComment, unlikeComment } from '../../api/feed';
import { CommentShimmer } from '../common/Shimmer';


export default function Comment({ whoLiked, likesCount, parentId, uid, text, author, time, commentList, mention }) {
    const { isDark } = useContext(DarkModeContext);
    const [userData, setUserData] = useState({ name: '', image: '', username: '' });
    const currentUser = useSelector(state => state.userState);
    const [loadingComment, setLoadingComment] = useState(true)

    const [comm, setComm] = useState(text)

    const dispatch = useDispatch();
    const history = useHistory()



    const isLiked = () => {
        const check = Object.entries(whoLiked).filter(a => a[0] == currentUser.id && a[1] == true);
        if (check.length > 0) return true;
        else return false;
    }

    const fetchUserData = async () => {
        const res = await getUserByID(author);
        setUserData(res);
        setLoadingComment(false)
    }

    const getTimeAgo = (time) => {
        try {
            return moment(new Date((time.seconds + time.nanoseconds * 10 ** -9) * 1000)).fromNow()
        } catch (e) { }
    }

    const handleReplyToggle = () => {
        dispatch({
            type: 'SET_C_I_NAME',
            payload: userData.username
        })
        dispatch({
            type: 'SET_COMMENT_PARENT_ID',
            payload: uid
        })
        dispatch({
            type: 'SET_COMMENT_INDICATOR',
            payload: true
        })

    }

    const openProfilePage = (e) => {
        // console.log(e)
        e.preventDefault()
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        history.push(`/user/${userData.username}`)

    }

    const handleOpenMentionedUser = (e) => {
        history.push(`/user/${e}`)
    }

    const handleCommentDelete = () => {
        deleteComment(parentId, uid)
    }

    const handleCommentLike = () => {
        likeComment(parentId, uid)
    }

    const handleCommentUnlike = () => {
        unlikeComment(parentId, uid);
    }

    const handleCommentAction = () => {
        isLiked() ? handleCommentUnlike() : handleCommentLike()
        isLiked()
    }

    useEffect(() => {
        // console.log(isLiked())
    }, [])

    useEffect(() => {
        setLoadingComment(true)
        fetchUserData();
    }, [])

    return (
        <div>
            {
                loadingComment ? 
                <div><CommentShimmer /></div> : 
                <div className="post-comment-widget">
                    <div>
                        {userData.name != "" && <div className="post-comment-widget-element">
                            <div className="post-comment-body">
                                <img onClick={openProfilePage} className="post-comment-author-pic" src={userData.image} />
                                <div className="post-comment-section">
                                    <div className="post-comment-author-and-text">
                                        <h1 onClick={openProfilePage} className={isDark ? 'post-comment-dark' : ''}>{userData.username} </h1><span dangerouslySetInnerHTML={{ __html: text }}></span>
                                    </div>
                                    <div onClick={handleReplyToggle} className="post-comment-actions">
                                        <p>{getTimeAgo(time)}</p>
                                        {likesCount > 0 ? <p2>{likesCount} likes</p2> : <p>&nbsp;</p>}


                                        <p3>Reply</p3>
                                    </div>
                                </div>
                            </div>
                            <img onClick={currentUser.id == author ? handleCommentDelete : handleCommentAction} src={currentUser.id != author ? isLiked() ? require('../../assets/icons/heart_a.svg') : require('../../assets/icons/heart.svg') : require('../../assets/icons/trash_a.svg')} />
                        </div>
                        }

                        <div>
                            {commentList.map(comment => {
                                if (comment.parent == uid)
                                    return <CommentReply parentId={parentId} whoLiked={comment.whoLiked} likesCount={comment.likesCount} key={comment.uid} id={comment.uid} uid={uid} text={comment.comment} author={comment.user} time={comment.time} />
                            })}
                        </div>
                    </div>

                </div>
            }
        </div>
    )
}
